import { EntitlementHotlistType as HotlistType } from "../guest/hotlist/entitlementHotlistType";

/** Hotlist Report Constants */
export const ALL_HOTLIST_ID = 999;
export const VERMONT_COVID_ATTESTATION = 12;
export const TREMBLANT_COVID_ATTESTATION = 16;
export const ALL_HOTLIST_REASON: HotlistType = { id: ALL_HOTLIST_ID, description: "All Hotlist Reasons" };